var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.92972C15.0006 3.83102 14.9816 3.73318 14.9443 3.64181C14.907 3.55044 14.852 3.46733 14.7825 3.39726L11.6025 0.217496C11.5324 0.14799 11.4493 0.0930006 11.3579 0.0556799C11.2665 0.0183593 11.1687 -0.000558092 11.07 1.25348e-05C10.9713 -0.000558092 10.8734 0.0183593 10.7821 0.0556799C10.6907 0.0930006 10.6076 0.14799 10.5375 0.217496L8.415 2.33984L0.217512 10.5367C0.148001 10.6068 0.0930074 10.6899 0.055684 10.7813C0.0183606 10.8726 -0.000558133 10.9705 1.25357e-05 11.0692V14.2489C1.25357e-05 14.4478 0.07903 14.6386 0.219682 14.7792C0.360334 14.9199 0.551099 14.9989 0.750011 14.9989H3.93001C4.03495 15.0046 4.13993 14.9882 4.23812 14.9507C4.33631 14.9133 4.42554 14.8556 4.5 14.7814L12.6525 6.58452L14.7825 4.49968C14.8509 4.42699 14.9067 4.34334 14.9475 4.25219C14.9547 4.19242 14.9547 4.13199 14.9475 4.07221C14.951 4.0373 14.951 4.00213 14.9475 3.96722L15 3.92972ZM3.62251 13.499H1.50001V11.3767L8.9475 3.92972L11.07 6.05206L3.62251 13.499ZM12.1275 4.99464L10.005 2.8723L11.07 1.81488L13.185 3.92972L12.1275 4.99464Z",
    fill: "#2E75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.30796385c006e3a63964d4bc82fd1034.svg";
export { ForwardRef as ReactComponent };